import { render } from "./PricingPreview.vue?vue&type=template&id=c88f1422&scoped=true"
import script from "./PricingPreview.vue?vue&type=script&lang=js"
export * from "./PricingPreview.vue?vue&type=script&lang=js"

import "./PricingPreview.vue?vue&type=style&index=0&id=c88f1422&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c88f1422"]])

export default __exports__